import { render, staticRenderFns } from "./LanguageChange2.vue?vue&type=template&id=9ed67a08&scoped=true&"
import script from "./LanguageChange2.vue?vue&type=script&lang=js&"
export * from "./LanguageChange2.vue?vue&type=script&lang=js&"
import style0 from "./LanguageChange2.vue?vue&type=style&index=0&id=9ed67a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed67a08",
  null
  
)

export default component.exports